import { useParams } from "react-router";
import { useSetPdfPageSize } from "@common/pdfPageSizeHelper";
import PolicyPdfContent from "./PolicyPdfContent";
import usePolicyPdfHooks from "./PolicyPdf.hooks";

function PolicyPdf() {
    const { policyId, versionId } = useParams<{ policyId: string; versionId: string }>();
    useSetPdfPageSize("portrait");

    const { data } = usePolicyPdfHooks();

    if (!data || !policyId || !versionId) return null;

    return <PolicyPdfContent data={data} isPdf />;
}

export default PolicyPdf;
